import { GroupListing } from "../../../../types";
import { Avatar, Box, Button, Skeleton, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { colors } from "../../../../theme/palette";
import { useTranslation } from "react-i18next";
import APP_ROUTES from "../../../../routers/routeConstants";

const GroupCard = ({
  group,
  handleSeeDetailsBtn,
}: {
  group: GroupListing;
  handleSeeDetailsBtn: (group: GroupListing) => void;
}) => {
  const { t } = useTranslation();
  const { name, imageLink, users } = group;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        rowGap: "16px",
        padding: "16px",
        borderRadius: "16px",
        background: colors.White,
        boxShadow: "0px 12px 20px 0px rgba(0, 0, 0, 0.04), 0px 0px 2px 0px rgba(0, 0, 0, 0.06)",
        height: "212.2px",
        width: "calc(30% - 7.5px)",
        textAlign: "center",
      }}
    >
      <Avatar src={imageLink} sx={{ width: "72px", height: "72px" }}>
        <Box component="span" sx={{ width: "72px", height: "72px", background: colors.Gray50 }}></Box>
      </Avatar>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          rowGap: "5px",
          maxWidth: "100%",
        }}
      >
        <Typography
          variant="body16SemiBold"
          sx={{
            color: colors.Dark1000,
            maxWidth: "100%",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
        >
          {name}
        </Typography>
        <Typography variant="body12Regular" sx={{ color: colors.Dark600 }}>
          {users.length} {t("pages.entity.groups.members")}
        </Typography>
      </Box>
      <Button fullWidth variant="text-sm" onClick={() => handleSeeDetailsBtn(group)}>
        {t("pages.entity.groups.seeDetails")}
      </Button>
    </Box>
  );
};

export default GroupCard;

export const CreateNewGroupCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        rowGap: "16px",
        padding: "16px",
        borderRadius: "16px",
        background: colors.White,
        boxShadow: "0px 12px 20px 0px rgba(0, 0, 0, 0.04), 0px 0px 2px 0px rgba(0, 0, 0, 0.06)",
        height: "212.2px",
        width: "calc(30% - 7.5px)",
        textAlign: "center",
      }}
    >
      <Box
        component="span"
        sx={{
          width: "72px",
          height: "72px",
          borderRadius: "50%",
          background: colors.Gray50,
        }}
      ></Box>

      <Box
        component="span"
        sx={{
          width: "126px",
          height: "5px",
          background: colors.Gray50,
          borderRadius: "50px",
        }}
      />
      <Box
        component="span"
        sx={{
          width: "93px",
          height: "5px",
          background: colors.Gray50,
          borderRadius: "50px",
        }}
      />
      <Button fullWidth variant="text-sm" onClick={() => navigate(APP_ROUTES.CREATE_GROUP)} sx={{ marginTop: "auto" }}>
        {t("pages.entity.groups.createNew")}
      </Button>
    </Box>
  );
};

export const GroupCardLoader = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        rowGap: "16px",
        padding: "16px",
        borderRadius: "16px",
        background: colors.White,
        boxShadow: "0px 12px 20px 0px rgba(0, 0, 0, 0.04), 0px 0px 2px 0px rgba(0, 0, 0, 0.06)",
        height: "212.2px",
        width: "calc(30% - 7.5px)",
        textAlign: "center",
      }}
    >
      <Avatar sx={{ width: "72px", height: "72px" }}>
        <Skeleton variant="circular" width={72} height={72} sx={{ background: colors.Gray50 }} />
      </Avatar>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          rowGap: "5px",
          maxWidth: "100%",
        }}
      >
        <Skeleton
          variant="text"
          height={24}
          width="70%"
          sx={{
            background: colors.Gray50,
            alignSelf: "center",
            borderRadius: "4px",
          }}
        />
        <Skeleton
          variant="text"
          height={16}
          width="50%"
          sx={{
            background: colors.Gray50,
            alignSelf: "center",
            borderRadius: "4px",
          }}
        />
      </Box>
      <Skeleton
        variant="rectangular"
        height={36}
        width="100%"
        sx={{ borderRadius: "4px", background: colors.Gray50 }}
      />
    </Box>
  );
};
